import React, { FC } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './delete_watcher_button.module.scss';
import { PrimaryButton } from '../../../components/button';

type Props = {
  tooltipId: string;
  deleteWatcher: () => void;
  place?: 'top' | 'right' | 'bottom' | 'left';
};

export const DeleteWatcherButton: FC<Props> = ({
  tooltipId,
  deleteWatcher,
  place,
}) => {
  const intl = useIntl();
  return (
    <div
      data-tip={intl.formatMessage({
        id: 'delete-watcher-button/DeleteWatcherButton.tsx/2',
      })}
      data-for={tooltipId}
      className={styles.button}
    >
      <PrimaryButton
        type="button"
        onClick={deleteWatcher}
        iconLeft="notifications"
      >
        <FormattedMessage id="delete-watcher-button/DeleteWatcherButton.tsx/1" />
      </PrimaryButton>
      <Tooltip id={tooltipId} effect="solid" place={place} />
    </div>
  );
};
